// extracted by mini-css-extract-plugin
export var bio = "bio-Lha";
export var bio_wrapper = "bio_wrapper-AiZ";
export var header = "header-eU2";
export var learn_more = "learn_more-WgM";
export var name = "name-bps";
export var profile_image = "profile_image-Yyy";
export var sme_tag = "sme_tag-LKY";
export var title = "title-4Bd";
export var wrapper = "wrapper-Ovj";